import { computed, defineComponent, ref } from 'vue';
import { RegistrationModel, RegistrationType } from "@/app/public/registrationModel";
import {useForm} from 'vee-validate';
import * as yup from 'yup';
import {toTypedSchema} from '@vee-validate/yup';
import {
    klValidationFields,
    ValidationFieldsType
} from '@/app/shared/components/kl-form-fields/kl-field-validation-util';

export default defineComponent({
    compatConfig: {
        MODE: 3,
    },
    name: 'KlRegistrationStep2',
    props: {
        registrationModel: {
            type: Object as () => RegistrationModel,
            required: true
        }
    },
    emits: ['change'],
    setup(props, { emit }) {
        const kboLink = 'https://kbopub.economie.fgov.be/kbopub/zoeknummerform.html?lang=nl';
        const ovoLink = 'https://wegwijs.vlaanderen.be/#/organisations';

        const schema = yup.object({
            organisationCode: yup.string().required().label('KBO- of OVO-code van uw organisatie'),
        })
        const form = useForm({
            validationSchema: toTypedSchema(schema)
        });
        const fields: ValidationFieldsType<typeof schema> = klValidationFields<typeof schema>(schema);

        const organisationCodeAnnotation = ref<string>(`<a href="${kboLink}" target="_blank" class="vl-link">KBO-nummer</a> of <a href="${ovoLink}" target="_blank" class="vl-link">OVO-code</a> van uw organisatie opzoeken`);

        const isCitizen = computed((): boolean => {
            return props.registrationModel.registrationType === RegistrationType.Citizen;
        });

        const organisationCode = computed({
            get: () => props.registrationModel.organisationCode,
            set: (value) => {
                fields.organisationCode.value.value = value;
                props.registrationModel.setOrganisationCode(value);
                emit('change', props.registrationModel);
            }
        });

        const isLegalRepresentative = computed({
            get: () => props.registrationModel.isLegalRepresentative,
            set: (value) => {
                props.registrationModel.setLegalRepresentative(value);
                emit('change', props.registrationModel);
            }
        });

        return {
            isCitizen,
            isLegalRepresentative,
            organisationCode,
            organisationCodeAnnotation,

            fields,
        }
    }
});
